import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, Text } from '@bonusly/design-system';

import { ReactComponent as EmptyStateIllustration } from '../../assets/cat-fishbowl.svg';

export const EmptyState: FC = () => {
	const { t } = useTranslation('feedback');

	return (
		<Flex direction="column" alignItems="center" py={12}>
			<EmptyStateIllustration />

			<Text fontWeight="md" fontSize="lg" my={2}>
				{t('not_found.header')}
			</Text>
		</Flex>
	);
};
